
import { AxiosResponse } from 'axios';
import { API } from '../utils/axios';
import { Chat } from '../hooks/useChats';
import { MessageReceivePayload } from '../datatypes';

export const getChats = (): Promise<AxiosResponse<Chat[]>> => API.get<Chat[]>('/chat');
export const getChat = (chatId: string): Promise<AxiosResponse<Chat>> => API.get<Chat>(`/chat/${chatId}`);

export const getChatMessages = (chatId: string): Promise<AxiosResponse<MessageReceivePayload[]>> => API.get<MessageReceivePayload[]>(`/chat/${chatId}/messages`);
export const getUserChatMessages = (userId: string): Promise<AxiosResponse<{ chat: Chat, messages: MessageReceivePayload[] }>> => API.get<{ chat: Chat, messages: MessageReceivePayload[] }>(`/chat/user/${userId}/messages`);
